import { useEffect } from 'react';

import { ArrowRight } from '@remarkable/ark-icons';
import { Typography } from '@remarkable/ark-web';

import { Trans } from '@lingui/react/macro';
import { ComponentRendered } from 'src/ampli';
import { tracker } from 'src/analytics/tracker';
import { Button } from 'src/components';
import { Highlight } from 'src/components/Highlight';
import { ValueProps } from 'src/components/Offers/ValueProps';
import { StackedSheet } from 'src/components/StackedSheet';
import { useFreeTrialDuration } from 'src/utils/freeTrialLength';
import { URLS } from 'src/utils/urls/urls';
import { valueProps } from 'src/utils/valueProps';

export const DmOffer = ({
  componentLocation,
  freeTrialLengthDays,
}: {
  componentLocation: string;
  freeTrialLengthDays: number;
}) => {
  const trialDuration = useFreeTrialDuration(freeTrialLengthDays);
  useEffect(() => {
    tracker.trackEvent(
      new ComponentRendered({
        component_name: 'DmOffer',
        component_type: 'hero',
      })
    );
  }, []);

  return (
    <StackedSheet dataCy="dmOffer-hero">
      <div className="flex gap-24 ll:gap-0">
        <div className="flex flex-col gap-24 text-left lm:gap-32">
          <div className="flex flex-col">
            <Typography variant="interface-sm" leadingNone uppercase>
              <Trans>Connect subscription</Trans>
            </Typography>
            <Typography
              variant="responsive-heading-lg"
              className="mt-8 mb-24 text-pretty lm:mt-24"
            >
              <Trans>
                Sync files to your{' '}
                <Highlight scale={320}>new paper tablet</Highlight>
              </Trans>
            </Typography>
            <Typography variant="responsive-body-md">
              <Trans>
                Activate your free {trialDuration} Connect trial to sync your
                notes to the cloud and access them on multiple devices.
              </Trans>
            </Typography>
          </div>

          <div data-cy="dm-offer-perks" className="w-full">
            <ValueProps
              className="justify-start"
              valueProps={valueProps.connect}
            />
          </div>

          <Button
            as="a"
            variant="primary"
            to={URLS.STORE_DM_OFFER_CHECKOUT}
            className="w-full lm:w-fit"
            data-cy="landing-next-step"
            analytics={{
              action: 'activate dm offer',
              location: componentLocation,
            }}
          >
            <span data-cy="dmOffer-activate-button">
              <Trans>Sync files</Trans>
            </span>
            <ArrowRight />
          </Button>
          <Typography variant="interface-sm" leadingNone>
            <Trans>
              Your trial will automatically end after 30 days if you don&apos;t
              add a payment method.
            </Trans>
          </Typography>
        </div>
      </div>
    </StackedSheet>
  );
};
